const MAX_UNACKNOWLEDGED_PROGRESS = 99

export function uploadProgressBeforeAcknowledgement(progress: number): number {
    return Math.min(progress, MAX_UNACKNOWLEDGED_PROGRESS)
}
